"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Growthbook = void 0;
var growthbook_1 = require("@growthbook/growthbook");
var analytics_js_1 = require("@rudderstack/analytics-js");
var Growthbook = /** @class */ (function () {
    // we have to pass settings due the specific framework implementation
    function Growthbook(clientKey, decryptionKey, settings) {
        if (settings === void 0) { settings = {}; }
        var _this = this;
        this.analytics = new analytics_js_1.RudderAnalytics();
        this.setAttributes = function (_a) {
            var id = _a.id, country = _a.country, user_language = _a.user_language, device_language = _a.device_language, device_type = _a.device_type, utm_source = _a.utm_source, utm_medium = _a.utm_medium, utm_campaign = _a.utm_campaign, is_authorised = _a.is_authorised, url = _a.url, domain = _a.domain, utm_content = _a.utm_content;
            var CURRENT_ATTRIBUTES = _this.GrowthBook.getAttributes();
            _this.GrowthBook.setAttributes(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, CURRENT_ATTRIBUTES), { id: id }), (country !== undefined && { country: country })), (user_language !== undefined && { user_language: user_language })), (device_language !== undefined && { device_language: device_language })), (device_type !== undefined && { device_type: device_type })), (utm_source !== undefined && { utm_source: utm_source })), (utm_medium !== undefined && { utm_medium: utm_medium })), (utm_campaign !== undefined && { utm_campaign: utm_campaign })), (is_authorised !== undefined && { is_authorised: is_authorised })), (url !== undefined && { url: url })), (domain !== undefined && { domain: domain })), (utm_content !== undefined && { utm_content: utm_content })));
        };
        this.getFeatureValue = function (key, defaultValue) {
            return _this.GrowthBook.getFeatureValue(key, defaultValue);
        };
        this.getFeatureState = function (id) { return _this.GrowthBook.evalFeature(id); };
        this.setUrl = function (href) { return _this.GrowthBook.setURL(href); };
        this.isOn = function (key) { return _this.GrowthBook.isOn(key); };
        this.init = function () { return _this.GrowthBook.loadFeatures().catch(function (err) { return console.error(err); }); };
        this.GrowthBook = new growthbook_1.GrowthBook(__assign({ apiHost: 'https://cdn.growthbook.io', clientKey: clientKey, decryptionKey: decryptionKey, antiFlicker: false, navigateDelay: 0, antiFlickerTimeout: 3500, subscribeToChanges: true, enableDevMode: window === null || window === void 0 ? void 0 : window.location.hostname.includes('localhost'), trackingCallback: function (experiment, result) {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'experiment_viewed',
                        event_category: 'experiment',
                        rudder_anonymous_id: _this.analytics.getAnonymousId(),
                        experiment_id: experiment.key,
                        variation_id: result.variationId,
                    });
                }
                _this.analytics.track('experiment_viewed', {
                    experimentId: experiment.key,
                    variationId: result.variationId,
                });
            } }, settings));
        this.init();
    }
    // for make instance by singleton
    Growthbook.getGrowthBookInstance = function (clientKey, decryptionKey, growthbookOptions) {
        if (!Growthbook._instance) {
            Growthbook._instance = new Growthbook(clientKey, decryptionKey, growthbookOptions);
            return Growthbook._instance;
        }
        return Growthbook._instance;
    };
    return Growthbook;
}());
exports.Growthbook = Growthbook;
